import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-card rounded-lg shadow p-6" }
const _hoisted_2 = { class: "mb-6 flex justify-between items-center" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  value: ""
}
const _hoisted_6 = {
  key: 1,
  value: ""
}
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_9 = { class: "flex gap-4" }
const _hoisted_10 = { class: "bg-background rounded-md p-4 border border-border min-w-[250px] h-[calc(100vh-200px)] flex flex-col" }
const _hoisted_11 = { class: "text-sm font-bold mb-4 flex items-center justify-between" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "text-xs bg-gray-200 text-gray-700 rounded-full px-2 py-0.5" }
const _hoisted_14 = { class: "flex-1 overflow-y-auto space-y-3 pr-2" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "flex justify-between items-start" }
const _hoisted_17 = { class: "font-medium text-sm" }
const _hoisted_18 = { class: "flex justify-between items-center mt-1" }
const _hoisted_19 = { class: "text-xs text-gray-500" }
const _hoisted_20 = {
  key: 0,
  class: "text-xs px-2 py-0.5 rounded-full bg-blue-600 text-white font-medium ml-2"
}
const _hoisted_21 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_22 = { class: "bg-background rounded-md p-4 border border-border min-w-[250px] h-[calc(100vh-200px)] flex flex-col" }
const _hoisted_23 = { class: "text-sm font-bold mb-4 flex items-center justify-between" }
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = { class: "text-xs bg-gray-200 text-gray-700 rounded-full px-2 py-0.5" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "font-medium text-sm" }
const _hoisted_28 = { class: "flex justify-between items-center mt-1" }
const _hoisted_29 = { class: "text-xs text-gray-500" }
const _hoisted_30 = {
  key: 0,
  class: "text-xs px-2 py-0.5 rounded-full bg-blue-600 text-white font-medium ml-2"
}
const _hoisted_31 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_32 = { class: "text-sm font-bold mb-4 flex items-center justify-between" }
const _hoisted_33 = { class: "flex items-center" }
const _hoisted_34 = { class: "text-xs bg-gray-200 text-gray-700 rounded-full px-2 py-0.5" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "font-medium text-sm" }
const _hoisted_37 = { class: "flex justify-between items-center mt-1" }
const _hoisted_38 = { class: "text-xs text-gray-500" }
const _hoisted_39 = {
  key: 0,
  class: "text-xs px-2 py-0.5 rounded-full bg-blue-600 text-white font-medium ml-2"
}
const _hoisted_40 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_41 = { class: "bg-background rounded-md p-4 border border-border min-w-[250px] h-[calc(100vh-200px)] flex flex-col" }
const _hoisted_42 = { class: "text-sm font-bold mb-4 flex items-center justify-between" }
const _hoisted_43 = { class: "flex items-center" }
const _hoisted_44 = { class: "text-xs bg-gray-200 text-gray-700 rounded-full px-2 py-0.5" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "font-medium text-sm" }
const _hoisted_47 = { class: "flex justify-between items-center mt-1" }
const _hoisted_48 = { class: "text-xs text-gray-500" }
const _hoisted_49 = {
  key: 0,
  class: "text-xs px-2 py-0.5 rounded-full bg-blue-600 text-white font-medium ml-2"
}
const _hoisted_50 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_51 = { class: "text-sm font-bold mb-4 flex items-center justify-between" }
const _hoisted_52 = { class: "flex items-center" }
const _hoisted_53 = { class: "text-xs bg-gray-200 text-gray-700 rounded-full px-2 py-0.5" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "font-medium text-sm" }
const _hoisted_56 = { class: "flex justify-between items-center mt-1" }
const _hoisted_57 = { class: "text-xs text-gray-500" }
const _hoisted_58 = {
  key: 0,
  class: "text-xs px-2 py-0.5 rounded-full bg-blue-600 text-white font-medium ml-2"
}
const _hoisted_59 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_60 = { class: "bg-background rounded-md p-4 border border-border min-w-[250px] h-[calc(100vh-200px)] flex flex-col" }
const _hoisted_61 = { class: "text-sm font-bold mb-4 flex items-center justify-between" }
const _hoisted_62 = { class: "flex items-center" }
const _hoisted_63 = { class: "flex items-center" }
const _hoisted_64 = { class: "text-xs bg-gray-200 text-gray-700 rounded-full px-2 py-0.5 mr-2" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = {
  key: 0,
  class: "animate-spin -ml-1 mr-2 h-3 w-3 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_67 = { class: "flex-1 overflow-y-auto space-y-2 pr-2" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "font-medium text-sm" }
const _hoisted_70 = { class: "flex justify-between items-center mt-1" }
const _hoisted_71 = { class: "text-xs text-gray-500" }
const _hoisted_72 = {
  key: 0,
  class: "text-xs px-2 py-0.5 rounded-full bg-blue-600 text-white font-medium ml-2"
}
const _hoisted_73 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_74 = {
  key: 0,
  class: "w-1/3 bg-white rounded-md shadow p-6 flex flex-col h-[calc(100vh-200px)]"
}
const _hoisted_75 = { class: "flex justify-between items-center mb-4" }
const _hoisted_76 = { class: "space-y-6 overflow-y-auto flex-1 pr-2" }
const _hoisted_77 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_78 = {
  key: 1,
  class: "flex items-center group"
}
const _hoisted_79 = { class: "text-lg font-semibold" }
const _hoisted_80 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_81 = { class: "flex justify-between items-start" }
const _hoisted_82 = { class: "w-1/2" }
const _hoisted_83 = { class: "flex items-center" }
const _hoisted_84 = { class: "text-sm" }
const _hoisted_85 = { class: "w-1/2" }
const _hoisted_86 = { class: "flex items-center" }
const _hoisted_87 = { class: "flex-shrink-0" }
const _hoisted_88 = ["src"]
const _hoisted_89 = {
  key: 1,
  class: "h-8 w-8 rounded-full bg-gray-200 mr-2 flex items-center justify-center"
}
const _hoisted_90 = { class: "text-gray-500 text-sm" }
const _hoisted_91 = { class: "text-sm font-medium" }
const _hoisted_92 = { class: "text-sm" }
const _hoisted_93 = { class: "pt-4 border-t border-gray-200" }
const _hoisted_94 = { class: "space-y-2" }
const _hoisted_95 = { class: "pt-4 border-t border-gray-200" }
const _hoisted_96 = {
  key: 0,
  class: "text-sm text-gray-500 italic"
}
const _hoisted_97 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_98 = { class: "flex items-start justify-between mb-2" }
const _hoisted_99 = { class: "flex items-center" }
const _hoisted_100 = { class: "flex-shrink-0" }
const _hoisted_101 = ["src", "alt"]
const _hoisted_102 = { class: "ml-2" }
const _hoisted_103 = { class: "text-sm font-medium" }
const _hoisted_104 = { class: "text-xs text-gray-500" }
const _hoisted_105 = { class: "text-sm text-gray-700" }
const _hoisted_106 = { class: "mt-4" }
const _hoisted_107 = { class: "flex gap-2" }
const _hoisted_108 = ["disabled"]
const _hoisted_109 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadedTemplateReviewModal = _resolveComponent("UploadedTemplateReviewModal")!
  const _component_DocumentTypesInfoModal = _resolveComponent("DocumentTypesInfoModal")!
  const _component_PlannerTemplateStatusModal = _resolveComponent("PlannerTemplateStatusModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "text-xl font-semibold" }, "Document Management", -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[20] || (_cache[20] = _createElementVNode("label", {
            for: "process-selector",
            class: "mr-2 text-sm font-medium text-gray-700"
          }, "Forecasting Process:", -1)),
          _withDirectives(_createElementVNode("select", {
            id: "process-selector",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProcessId) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleProcessChange && _ctx.handleProcessChange(...args))),
            class: "bg-white border border-gray-300 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-64 p-2.5",
            disabled: _ctx.loading
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("option", _hoisted_5, "Loading processes..."))
              : (_ctx.processes.length === 0)
                ? (_openBlock(), _createElementBlock("option", _hoisted_6, "No processes available"))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processes, (process) => {
              return (_openBlock(), _createElementBlock("option", {
                key: process.id,
                value: process.id
              }, _toDisplayString(process.name) + " (" + _toDisplayString(_ctx.formatProcessDate(process.start_date)) + ") ", 9, _hoisted_7))
            }), 128))
          ], 40, _hoisted_4), [
            [_vModelSelect, _ctx.selectedProcessId]
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[19] || (_cache[19] = [
                _createElementVNode("svg", {
                  class: "animate-spin h-5 w-5 text-blue-500",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })
                ], -1)
              ])))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(['grid grid-cols-1 md:grid-cols-4 gap-4 overflow-x-auto', _ctx.selectedDocument ? 'w-2/3' : 'w-full'])
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h3", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "w-3 h-3 rounded-full bg-green-700 mr-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.formatDOCUMENT_STATUS(_ctx.DOCUMENT_STATUS.CREATING)) + " ", 1),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.preparePlannerTemplate && _ctx.preparePlannerTemplate(...args))),
                  class: "ml-2 px-2 py-1 text-xs rounded-md transition-colors flex items-center bg-primary text-white hover:bg-primary/90"
                }, _cache[22] || (_cache[22] = [
                  _createElementVNode("svg", {
                    class: "h-3 w-3 mr-1",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    })
                  ], -1),
                  _createTextVNode(" Prepare Templates ")
                ]))
              ]),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.creatingDocuments.length), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creatingDocuments, (doc, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'creating-' + index,
                  class: _normalizeClass(["bg-white p-3 rounded shadow-sm border border-gray-200 cursor-pointer hover:shadow-md transition-shadow", { 'ring-2 ring-primary': _ctx.selectedDocument?.id === doc.id }]),
                  onClick: ($event: any) => (_ctx.selectDocument(doc))
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(doc.name), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["text-xs px-2 py-0.5 rounded-full font-medium", {
                  'bg-green-100 text-green-800': doc.status === _ctx.DOCUMENT_STATUS.CREATING,
                  'bg-blue-100 text-blue-800': doc.status === _ctx.DOCUMENT_STATUS.REVIEW_CREATED,
                  'bg-yellow-100 text-yellow-800': doc.status === _ctx.DOCUMENT_STATUS.EMAIL_PENDING
                }])
                    }, _toDisplayString(_ctx.formatDOCUMENT_STATUS(doc.status)), 3)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(doc.description), 1),
                    (doc.report_type)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(doc.report_type), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_21, "By: " + _toDisplayString(doc.created_by_name), 1)
                ], 10, _hoisted_15))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("h3", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "w-3 h-3 rounded-full bg-yellow-400 mr-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.formatDOCUMENT_STATUS(_ctx.DOCUMENT_STATUS.READY_FOR_DOWNLOAD)), 1)
              ]),
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.readyForDownloadDocuments.length), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass([
            'overflow-y-auto space-y-3 pr-2 mb-6',
            _ctx.readyForDownloadDocuments.length > 0 ? 'flex-1' : '',
            _ctx.downloadedDocuments.length === 0 && _ctx.readyForDownloadDocuments.length > 0 ? 'flex-grow' : ''
          ])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.readyForDownloadDocuments, (doc, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'ready-' + index,
                  class: _normalizeClass(["bg-white p-3 rounded shadow-sm border border-gray-200 cursor-pointer hover:shadow-md transition-shadow", { 'ring-2 ring-primary': _ctx.selectedDocument?.id === doc.id }]),
                  onClick: ($event: any) => (_ctx.selectDocument(doc))
                }, [
                  _createElementVNode("div", _hoisted_27, _toDisplayString(doc.name), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, _toDisplayString(doc.description), 1),
                    (doc.report_type)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(doc.report_type), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_31, "By: " + _toDisplayString(doc.created_by_name), 1)
                ], 10, _hoisted_26))
              }), 128))
            ], 2),
            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "border-t border-gray-200 my-4" }, null, -1)),
            _createElementVNode("h3", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "w-3 h-3 rounded-full bg-green-700 mr-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.formatDOCUMENT_STATUS(_ctx.DOCUMENT_STATUS.DOWNLOADED)), 1)
              ]),
              _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.downloadedDocuments.length), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass([
            'overflow-y-auto space-y-3 pr-2',
            _ctx.downloadedDocuments.length > 0 ? 'flex-1' : '',
            _ctx.readyForDownloadDocuments.length === 0 && _ctx.downloadedDocuments.length > 0 ? 'flex-grow' : ''
          ])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downloadedDocuments, (doc, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'downloaded-' + index,
                  class: _normalizeClass(["bg-white p-3 rounded shadow-sm border border-gray-200 cursor-pointer hover:shadow-md transition-shadow", { 'ring-2 ring-primary': _ctx.selectedDocument?.id === doc.id }]),
                  onClick: ($event: any) => (_ctx.selectDocument(doc))
                }, [
                  _createElementVNode("div", _hoisted_36, _toDisplayString(doc.name), 1),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, _toDisplayString(doc.description), 1),
                    (doc.report_type)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(doc.report_type), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_40, "By: " + _toDisplayString(doc.created_by_name), 1)
                ], 10, _hoisted_35))
              }), 128))
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("h3", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "w-3 h-3 rounded-full bg-green-700 mr-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.formatDOCUMENT_STATUS(_ctx.DOCUMENT_STATUS.UPLOADED_CHECKING)), 1)
              ]),
              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.uploadedAndCheckingDocuments.length), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass([
            'overflow-y-auto space-y-3 pr-2 mb-6',
            _ctx.uploadedAndCheckingDocuments.length > 0 ? 'flex-1' : '',
            _ctx.adjustmentNeededDocuments.length === 0 && _ctx.uploadedAndCheckingDocuments.length > 0 ? 'flex-grow' : ''
          ])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadedAndCheckingDocuments, (doc, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'uploaded-' + index,
                  class: _normalizeClass(["bg-white p-3 rounded shadow-sm border border-gray-200 cursor-pointer hover:shadow-md transition-shadow", { 'ring-2 ring-primary': _ctx.selectedDocument?.id === doc.id }]),
                  onClick: ($event: any) => (_ctx.selectDocument(doc))
                }, [
                  _createElementVNode("div", _hoisted_46, _toDisplayString(doc.name), 1),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, _toDisplayString(doc.description), 1),
                    (doc.report_type)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(doc.report_type), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_50, "By: " + _toDisplayString(doc.created_by_name), 1)
                ], 10, _hoisted_45))
              }), 128))
            ], 2),
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "border-t border-gray-200 my-4" }, null, -1)),
            _createElementVNode("h3", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "w-3 h-3 rounded-full bg-yellow-400 mr-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.formatDOCUMENT_STATUS(_ctx.DOCUMENT_STATUS.ADJUSTMENT_NEEDED)), 1)
              ]),
              _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.adjustmentNeededDocuments.length), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass([
            'overflow-y-auto space-y-3 pr-2',
            _ctx.adjustmentNeededDocuments.length > 0 ? 'flex-1' : '',
            _ctx.uploadedAndCheckingDocuments.length === 0 && _ctx.adjustmentNeededDocuments.length > 0 ? 'flex-grow' : ''
          ])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adjustmentNeededDocuments, (doc, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'adjustment-' + index,
                  class: _normalizeClass(["bg-white p-3 rounded shadow-sm border border-gray-200 cursor-pointer hover:shadow-md transition-shadow", { 'ring-2 ring-primary': _ctx.selectedDocument?.id === doc.id }]),
                  onClick: ($event: any) => (_ctx.selectDocument(doc))
                }, [
                  _createElementVNode("div", _hoisted_55, _toDisplayString(doc.name), 1),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, _toDisplayString(doc.description), 1),
                    (doc.report_type)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(doc.report_type), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_59, "By: " + _toDisplayString(doc.created_by_name), 1)
                ], 10, _hoisted_54))
              }), 128))
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("h3", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "w-3 h-3 rounded-full bg-blue-500 mr-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.formatDOCUMENT_STATUS(_ctx.DOCUMENT_STATUS.REVISION_NEEDED)) + " ", 1),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showDocumentTypesInfo && _ctx.showDocumentTypesInfo(...args))),
                  class: "ml-2 text-gray-500 hover:text-gray-700 focus:outline-none",
                  title: "Show document types status"
                }, _cache[30] || (_cache[30] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: "h-4 w-4",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    })
                  ], -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("span", _hoisted_64, "[" + _toDisplayString(_ctx.availableDocumentTypesCount) + "/" + _toDisplayString(_ctx.allReportTypes.length) + "]", 1),
                (_ctx.readyForRevisionDocuments.length > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.mergeRevisionDocuments && _ctx.mergeRevisionDocuments(...args))),
                      disabled: _ctx.isMerging,
                      class: "text-xs px-2 py-1 bg-primary text-white rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                    }, [
                      (_ctx.isMerging)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_66, _cache[32] || (_cache[32] = [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }, null, -1),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            }, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.isMerging ? 'Merging...' : 'Merge Documents'), 1)
                    ], 8, _hoisted_65))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_67, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.readyForRevisionDocuments, (doc, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'revision-' + index,
                  class: _normalizeClass(["bg-white py-2 px-3 rounded shadow-sm border border-gray-200 cursor-pointer hover:shadow-md transition-shadow", { 'ring-2 ring-primary': _ctx.selectedDocument?.id === doc.id }]),
                  onClick: ($event: any) => (_ctx.selectDocument(doc))
                }, [
                  _createElementVNode("div", _hoisted_69, _toDisplayString(doc.name), 1),
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, _toDisplayString(doc.description), 1),
                    (doc.report_type)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(doc.report_type), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_73, "By: " + _toDisplayString(doc.created_by_name), 1)
                ], 10, _hoisted_68))
              }), 128))
            ])
          ])
        ], 2),
        _createVNode(_Transition, {
          "enter-active-class": "transition-all duration-300 ease-out",
          "enter-from-class": "transform translate-x-full opacity-0",
          "enter-to-class": "transform translate-x-0 opacity-100",
          "leave-active-class": "transition-all duration-300 ease-in",
          "leave-from-class": "transform translate-x-0 opacity-100",
          "leave-to-class": "transform translate-x-full opacity-0"
        }, {
          default: _withCtx(() => [
            (_ctx.selectedDocument)
              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, [
                    _cache[34] || (_cache[34] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Document Details", -1)),
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedDocument && _ctx.clearSelectedDocument(...args))),
                      class: "text-gray-500 hover:text-gray-700"
                    }, _cache[33] || (_cache[33] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-5 w-5",
                        viewBox: "0 0 20 20",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                          "clip-rule": "evenodd"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", null, [
                      _cache[36] || (_cache[36] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-500 mb-1" }, "Document Name", -1)),
                      (_ctx.isEditingName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editedName) = $event)),
                              ref: "nameInput",
                              class: "text-lg font-semibold border border-gray-300 rounded-md mx-1 p-1 w-full focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent",
                              onKeyup: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.saveDocumentName && _ctx.saveDocumentName(...args)), ["enter"])),
                              onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveDocumentName && _ctx.saveDocumentName(...args)))
                            }, null, 544), [
                              [_vModelText, _ctx.editedName]
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_78, [
                            _createElementVNode("p", _hoisted_79, [
                              _createTextVNode(_toDisplayString(_ctx.selectedDocument.name) + " ", 1),
                              (_ctx.selectedDocument.process_name)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_80, " (" + _toDisplayString(_ctx.selectedDocument.process_name) + ") ", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("button", {
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.startEditingName && _ctx.startEditingName(...args))),
                              class: "ml-1 text-gray-500 hover:text-primary focus:outline-none transition-colors opacity-0 group-hover:opacity-100 relative z-10"
                            }, _cache[35] || (_cache[35] = [
                              _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "mb-1 h-4 w-4",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                })
                              ], -1)
                            ]))
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _cache[37] || (_cache[37] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-500 mb-1" }, "Status", -1)),
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-3 h-3 rounded-full mr-2", {
                    'bg-green-700': _ctx.selectedDocument.status === _ctx.DOCUMENT_STATUS.CREATING ||
                      _ctx.selectedDocument.status === _ctx.DOCUMENT_STATUS.DOWNLOADED ||
                      _ctx.selectedDocument.status === _ctx.DOCUMENT_STATUS.UPLOADED_CHECKING,
                    'bg-yellow-400': _ctx.selectedDocument.status === _ctx.DOCUMENT_STATUS.READY_FOR_DOWNLOAD ||
                      _ctx.selectedDocument.status === _ctx.DOCUMENT_STATUS.ADJUSTMENT_NEEDED,
                    'bg-blue-500': _ctx.selectedDocument.status === _ctx.DOCUMENT_STATUS.REVISION_NEEDED
                  }])
                          }, null, 2),
                          _createElementVNode("span", _hoisted_84, _toDisplayString(_ctx.formatDOCUMENT_STATUS(_ctx.selectedDocument.status)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _cache[38] || (_cache[38] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-500 mb-1" }, "Owner", -1)),
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("div", _hoisted_87, [
                            (_ctx.selectedDocument.created_by_avatar_url)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.selectedDocument.created_by_avatar_url,
                                  alt: "Avatar",
                                  class: "h-8 w-8 rounded-full mr-2"
                                }, null, 8, _hoisted_88))
                              : (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                  _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.selectedDocument.created_by_name?.charAt(0) || '?'), 1)
                                ]))
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_91, _toDisplayString(_ctx.selectedDocument.created_by_name), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[39] || (_cache[39] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-500 mb-1" }, "Description", -1)),
                      _createElementVNode("p", _hoisted_92, _toDisplayString(_ctx.selectedDocument.description), 1)
                    ]),
                    _createElementVNode("div", _hoisted_93, [
                      _cache[40] || (_cache[40] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-500 mb-3" }, "Actions", -1)),
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("button", {
                          class: _normalizeClass([
                  'w-full px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2',
                  _ctx.selectedDocument.status === _ctx.DOCUMENT_STATUS.READY_FOR_DOWNLOAD
                    ? 'bg-primary text-white hover:bg-primary/90 focus:ring-primary'
                    : 'bg-transparent text-gray-700 border border-gray-500 hover:bg-gray-100 focus:ring-gray-500'
                ]),
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedDocument?.id && _ctx.downloadDocument(_ctx.selectedDocument.id)))
                        }, " Download Document ", 2),
                        (_ctx.selectedDocument.status === _ctx.DOCUMENT_STATUS.ADJUSTMENT_NEEDED)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.openEmailReviewModal && _ctx.openEmailReviewModal(...args))),
                              class: "w-full mt-2 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                            }, " Review and Send Email to Planner "))
                          : _createCommentVNode("", true),
                        (_ctx.selectedDocument.status === _ctx.DOCUMENT_STATUS.REVIEW_CREATED)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.openSpreadsheetReviewModal && _ctx.openSpreadsheetReviewModal(...args))),
                              class: "w-full mt-2 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                            }, " Review Prefilled Template "))
                          : _createCommentVNode("", true),
                        (_ctx.selectedDocument.status === _ctx.DOCUMENT_STATUS.EMAIL_PENDING)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.openEmailReviewModal && _ctx.openEmailReviewModal(...args))),
                              class: "w-full mt-2 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                            }, " Review and Send Email to Planner "))
                          : _createCommentVNode("", true),
                        (_ctx.selectedDocument.status === _ctx.DOCUMENT_STATUS.UPLOADED_CHECKING)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.openUploadedTemplateReviewModal && _ctx.openUploadedTemplateReviewModal(...args))),
                              class: "w-full mt-2 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                            }, " Review Uploaded Template and Findings "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _cache[41] || (_cache[41] = _createElementVNode("h4", { class: "text-sm font-medium text-gray-500 mb-3" }, "Comments", -1)),
                      (_ctx.comments.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_96, " No comments yet "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_97, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (comment) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: comment.id,
                                class: "bg-gray-50 rounded-lg p-3"
                              }, [
                                _createElementVNode("div", _hoisted_98, [
                                  _createElementVNode("div", _hoisted_99, [
                                    _createElementVNode("div", _hoisted_100, [
                                      _createElementVNode("img", {
                                        src: comment.created_by_avatar_url,
                                        alt: comment.created_by_name,
                                        class: "h-8 w-8 rounded-full object-cover"
                                      }, null, 8, _hoisted_101)
                                    ]),
                                    _createElementVNode("div", _hoisted_102, [
                                      _createElementVNode("p", _hoisted_103, _toDisplayString(comment.created_by_name || 'Unknown User'), 1),
                                      _createElementVNode("p", _hoisted_104, _toDisplayString(new Date(comment.created_at).toLocaleDateString('sl-SI', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric'
                          }).replace(',', '')) + ", " + _toDisplayString(new Date(comment.created_at).toLocaleTimeString('sl-SI', {
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false
                          })), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("p", _hoisted_105, _toDisplayString(comment.content), 1)
                              ]))
                            }), 128))
                          ])),
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("div", _hoisted_107, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.newComment) = $event)),
                            type: "text",
                            placeholder: "Add a comment...",
                            class: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent",
                            onKeyup: _cache[16] || (_cache[16] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addComment && _ctx.addComment(...args)), ["enter"]))
                          }, null, 544), [
                            [_vModelText, _ctx.newComment]
                          ]),
                          _createElementVNode("button", {
                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.addComment && _ctx.addComment(...args))),
                            disabled: !_ctx.newComment.trim(),
                            class: "px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                          }, " Send ", 8, _hoisted_108)
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_UploadedTemplateReviewModal, {
        "is-open": _ctx.showUploadedTemplateReviewModal,
        "document-data": _ctx.selectedDocument || {},
        onClose: _ctx.closeUploadedTemplateReviewModal,
        onStatusUpdated: _ctx.handleStatusUpdate
      }, null, 8, ["is-open", "document-data", "onClose", "onStatusUpdated"]),
      _createVNode(_component_DocumentTypesInfoModal, {
        "is-open": _ctx.showDocumentTypesInfoModal,
        "document-types-status": _ctx.documentTypesStatus,
        "show-merge-anyway-button": _ctx.readyForRevisionDocuments.length > 0 && !_ctx.allDocumentTypesAvailable && _ctx.isModalOpenedFromMergeButton,
        "merged-documents": _ctx.mergedDocuments,
        onClose: _ctx.closeDocumentTypesInfoModal,
        onMergeAnyway: _ctx.performMerge,
        onDownloadDocument: _ctx.downloadMergedDocument,
        onDeleteDocument: _ctx.deleteMergedDocument
      }, null, 8, ["is-open", "document-types-status", "show-merge-anyway-button", "merged-documents", "onClose", "onMergeAnyway", "onDownloadDocument", "onDeleteDocument"]),
      _createVNode(_component_PlannerTemplateStatusModal, {
        "is-open": _ctx.showPlannerTemplateStatusModal,
        "forecast-id": _ctx.selectedProcessId,
        "planner-status": _ctx.plannerTemplateStatus,
        onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showPlannerTemplateStatusModal = false)),
        onPrepareTemplate: _ctx.preparePlannerTemplateForType,
        onPrepareAllMissing: _ctx.prepareAllMissingTemplates
      }, null, 8, ["is-open", "forecast-id", "planner-status", "onPrepareTemplate", "onPrepareAllMissing"])
    ]),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_109, _cache[42] || (_cache[42] = [
          _createStaticVNode("<div class=\"bg-white p-6 rounded-lg shadow-lg\"><div class=\"flex items-center\"><svg class=\"animate-spin h-5 w-5 mr-3 text-primary\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z\"></path></svg><span>Preparing templates...</span></div></div>", 1)
        ])))
      : _createCommentVNode("", true)
  ], 64))
}